import $ from 'jquery';

(function (root, $, undefined) {

  "use strict";

  $(function () {

    var sliders = [];
    var st;
    var headerTop = 0;
    var increment = 0;
    var lastScrollTop = 0;
    var element = document.getElementsByTagName('header');

    $.fn.isInViewport = function (offset) {
      if(!offset) {
        offset = 0;
      }
      var elementTop = $(this).offset().top + offset;
      var elementBottom = elementTop + $(this).outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      return elementBottom > viewportTop && elementTop < viewportBottom;
    };
    
    $(function() { 
      is_mobile();

      // thisLazyLoad();
      document.addEventListener("scroll", thisLazyLoad);
      window.addEventListener("resize", thisLazyLoad);
      window.addEventListener("orientationchange", thisLazyLoad);

      document.addEventListener("wpcf7submit", function(){
        setTimeout(() => {
          reVerifyCheckbox();
        }, 500);
      });

      var ua = navigator.userAgent.toLowerCase();
      var isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
      if(isAndroid) {
        document.body.className += ' is_android'; 
      }

      setCommon();
      menu_listener();
      detect_touch();
      // checkFormFiels();

      // checkScrollClass();
      check_header_fromMobile();
      handleProdImageAnimation();
      
      initSwiper();
      initLightCase();
      initNumScroller();

      handleInlineVideo();
    });

    $(window).on('load', function(){
      manageAccordion();
    });
      
    $(window).on('resize', function(){
      if (this.resizeTO) clearTimeout(this.resizeTO);
      this.resizeTO = setTimeout(function () {
          $(this).trigger('resizeEnd');
      }, 300);
    });

    $(window).on('scroll', function(){
      if($('body').hasClass('menu_open') && $(window).width()+getScrollBarWidth() <= 980){
        fix_header_for_menuopen();
      } else {
        header_mvmnt();
      }
    });

    $(window).on('resizeEnd', function() {
      manageAccordion();
      // checkScrollClass();
    });


    $(document).ajaxComplete(function(){
      reVerifyCheckbox();
      thisLazyLoad();
    });

    function manageAccordion() {
      $('.single_modello').each(function(){
        var submenu = $(this);
        var vw = $(window).width();
        submenu.css('max-height',submenu[0].scrollHeight + 40 + (vw / 100 * 4));
      });

      $('.accordion_content').each(function(){
        var submenu = $(this);        
        // console.log(submenu[0].scrollHeight);
        submenu.css('max-height',submenu[0].scrollHeight + 60);
      });

      $('.categorie_drpdwn > ul').each(function(){
        var submenu = $(this);
        var totalHeight = 0;  

        submenu.find('li').each(function(){
          var subelem = $(this);
          totalHeight += subelem[0].scrollHeight;
        });
        
        submenu.css('max-height',totalHeight + 50);
      });

      // $('.categorie_drpdwn > ul').each(function(){
      //   var submenu = $(this);
      //   submenu.css('max-height',submenu[0].scrollHeight + 20);
      // });
    } 

    function setCommon() {

      $('a[data-rel^=goto]').on('click',function(){
        var this_link = $(this);
        var attrs = this_link.data('goto');
        if(attrs != null && attrs != "") {
          var res = attrs.split(',');
          var offset = typeof res[1] !== "undefined" ? parseInt(res[1]) : null;
          var velocity = typeof res[2] !== "undefined" ? parseInt(res[2]) : 2000;
          thisGoTo(res[0], offset, velocity, res[3]);
        }
      });

      $('body').on('click','.scrollDown',function(e){
        if($('.section_1').length > 0){
          thisGoTo('.section_1',-80);
        }
      });

      $('.woocommerce-form__label-for-checkbox').addClass('checkbox');

      $('body').on('click','label.checkbox',function(){
        if($(this).closest('.woocommerce-checkout').length > 0 || $(this).closest('.woocommerce-form-login').length > 0) {
          label_checkbox_toggle($(this));
        } else {
          label_checkbox_toggle($(this).find('.wpcf7-list-item'));
        }
      });

      $('body').on('focus mouseover','article.type-prodotti',function(){
        checkHoverImage(this);
      });
      $('body').on('focus mouseover','article.type-cocktail',function(){
        checkHoverImage(this);
      });


      $('body').on('click','.categorie_drpdwn', function(){
        $(this).toggleClass('dropdown_open');
      });

      $('body').on('click', function(e){
        if(!$('categorie_drpdwn').is(e.target) && $('.box_cat_dropdown').has(e.target).length === 0 ) {
          $('.categorie_drpdwn').removeClass('dropdown_open');
        }
      });
      

      // fix lazy-loading images in a lower point while rendering swipers
      setTimeout(function(){
        thisLazyLoad();
      }, 200);

    }

    function reVerifyCheckbox() {
      $('input[type=checkbox]').each(function(){
        var el = $(this).closest('.checkbox');

        if(el.closest('.woocommerce-checkout').length > 0 || el.closest('.woocommerce-form-login').length > 0) {
          label_checkbox_toggle(el);
        } else {
          label_checkbox_toggle(el.find('.wpcf7-list-item'));
        }
      });
    }

    function label_checkbox_toggle($label) {
      var $parent = $label;
      var $el = $label.find('input[type="checkbox"]');
      if($el.is(':checked')){
          $parent.addClass('checked');
      } else {
          $parent.removeClass('checked');
      }
    }

    // function checkScrollClass() {
    //   $(window).on('load scroll', function(){ scrolledClass() });
    // } 

    // var last_wh;
    // const scrolledClass = function () {
      
    //   if($('.initial_banner').length > 0) {
    //     var wh = $('.initial_banner')[0].scrollHeight - 100; 
    //   } else {
    //     var wh = 50;
    //   }
  
    //   if ($(window).scrollTop() >= (wh)) {
    //     if (!$('body').hasClass('scrolled'))
    //       $('body').addClass('scrolled');
    //   } else {
    //     if ($('body').hasClass('scrolled'))
    //       $('body').removeClass('scrolled');
    //   }
    // }

    let listProdImg;
    let listCocktailImg;
    
    function handleProdImageAnimation() {
      var singleProdImg = $('.single-prodotti .product_image');
      if(singleProdImg.length > 0) {
        $(window).on('scroll resize mousemove', function() {
          if (singleProdImg.isInViewport()) {
            $('body').addClass('load_prod_img');
          } else {
            $('body').removeClass('load_prod_img');
          }
        });
      }
      
      listProdImg = [].slice.call(document.querySelectorAll("article.type-prodotti .product_image"));
      listCocktailImg = [].slice.call(document.querySelectorAll("article.type-cocktail .cocktail_image"));

      listProdImg = listProdImg.concat(listCocktailImg);
      
      if(listProdImg.length > 0) { 
        document.addEventListener("scroll", listProdAnim);
        window.addEventListener("resize", listProdAnim);
      }

    }

    const listProdAnim = () => {
      listProdImg.forEach(prodImg => {
        if ($(prodImg).isInViewport($(prodImg).outerHeight() / 1.5)) {
          checkHoverImage(prodImg);
          if($(prodImg).hasClass('product_image')){
            $(prodImg).addClass('active');
          }
          listProdImg = listProdImg.filter(function (image) {
            return image !== prodImg;
          });
        } 
        if (listProdImg.length === 0) {
          document.removeEventListener("scroll", listProdAnim);
          window.removeEventListener("resize", listProdAnim);
        }
      });

    }

      
    function checkHoverImage(elem) {
      var imgs = [].slice.call(elem.getElementsByClassName('hover_img'));
        
      imgs.forEach(function (img) {
        if(!img.classList.contains('src_loaded')){
          if(img.dataset.srchover !== undefined)
            img.src = img.dataset.srchover;
          if(img.dataset.srchoverset !== undefined)
            img.srcset = img.dataset.srchoverset;

          img.classList.add("src_loaded");              
        }
      });
    }
      

    const initNumScroller = () => {
      if ($(".numscroller").length > 0) {
        import("../../includes/js/numscroller-1.0.js");
      }
    }

    function move(duration,customProgressRdm) {
      var progressbar = document.getElementById("time-progress-"+customProgressRdm);
      progressbar.classList.remove("animate");
      void progressbar.offsetWidth;
      progressbar.classList.add("animate");
      progressbar.style.animationDuration = `${duration}ms`;
    }

    const initSwiper = () => {
      if ($(".swiper").length > 0) {
        import("swiper/swiper.min.css");
        import("swiper/css/effect-fade");
        import("swiper/css/free-mode");
        import("swiper")
          .then((module) => {
            module.Swiper.use([
              module.Autoplay,
              module.Navigation,
              module.EffectFade,
              module.Pagination,
              module.FreeMode,
              module.Lazy
            ]);
  
            $(".swiper").each((index, item) => {
              const data = $(item).data("slideshow");
  
              if (data && data.customProgressRdm) {
                var customProgressRdm = data.customProgressRdm;
                delete data.customProgressRdm;

                if(!data.on){
                  data['on'] = [];
                }
                data.on['init'] = function(){
                  if (data.autoplay && customProgressRdm) {
                    move(data.autoplay.delay, customProgressRdm);
                  }
                };
                data.on['slideChangeTransitionStart'] = function() {
                  if (data.autoplay && customProgressRdm) {
                    move(data.autoplay.delay + 1000, customProgressRdm);
                  }
                };
              }
              if (data && data.pagination && data.pagination.type == 'bullets') {
                data.pagination.renderBullet = (index, className) => {
                  return '<span class="' + className + '"><span>' + (index + 1) + '</span></span>';
                };
              }
              if (data && data.pagination && data.pagination.type == 'fraction') {
                data.pagination.renderFraction = (currentClass, totalClass) => {
                  return '<span class="' + currentClass + '"></span><span class="' + totalClass + '"></span>';
                };
                data.pagination.formatFractionCurrent = (currentNumber) => {
                  return ('0' + currentNumber).slice(-2);
                }
                data.pagination.formatFractionTotal = (totalNumber) => {
                  return ('0' + totalNumber).slice(-2);
                }
              }
  
              if (data && !data.disabled) {
                const slider = new module.Swiper(item, {
                  ...data
                });
                sliders.push(slider);
              } else {
                $(item).find(".swiper-button-next").hide();
                $(item).find(".swiper-button-prev").hide();
                $(item).find(".swiper-pagination").hide();
              }
            });
          })
          .catch((e) => {
            console.log("Error loading swiper: ", e);
          });
      }
    };

    const initLightCase = () => {
      if ($("[data-fancybox]").length > 0) {
        import("@fancyapps/ui/dist/fancybox/fancybox.css").then(() => {
            const fancyapps = require('@fancyapps/ui/dist/fancybox/fancybox.umd.js');
            if(fancyapps.Fancybox){
              const Fancybox = fancyapps.Fancybox;
              Fancybox.bind("[data-fancybox]", {
                // Your custom options
              });
            }
          }
        );
      };

      if ($("a[data-rel^=lightcase]").length > 0) {
        import("lightcase/src/css/lightcase.css");
        import("lightcase").then(() => {
          $("a[data-rel^=lightcase]").lightcase({
            maxHeight: 1280,
            maxWidth: 1920,
            video: {
              autoplay: true,
              width: "1280px",
              height: "720px",
            },
            iframe: {
              width: "1280px",
              height: "720px",
            },
          });
        });
      }
    };


    function menu_listener(){

      $('a[href="#"]').on('click',function(e){
          e.preventDefault();
      });

      $('body').on('click','.cango', function(){
        addCookie('legalAgeForDrinking');
        $('body').addClass('closeSplashpage');
      });
      $('body').on('click','.cantgo', function(){
        $('.splashpage').addClass('failed');
      });
      $('body').on('click','.splashpage .button_container .back', function(){
        $('.splashpage').removeClass('failed');
      });

      $('a[href="#form"]').on('click',function(e){
          e.preventDefault();
          thisGoTo('.footer_form',-50);
      });

      $('a[href="#newsletter"]').on('click',function(e){
          e.preventDefault();
          $('body').addClass('form_open');
      });

      $('body').on('click',function(e){
        if($(e.target).is('body') && $(e.target).hasClass('form_open')){
          $('body').removeClass('form_open');
        }
        if($(e.target).is('body') && $(e.target).hasClass('search_open')){
          $('body').removeClass('search_open');
        }
      });
      
      $('body').on('click','.search_opener', function(){
        $('body').toggleClass('search_open');
        if($("body").hasClass("search_open")) {
          $(".search-input").trigger("focus")
        }
      });

      $('body').on('click','.close_menu', function(){
        $('body').removeClass('menu_open');
        handleMenuVideo(false);
      });
      $('body').on('click','.close_popup', function(){
        $('body').removeClass('form_open');
      });

      $('body').on('click','.scrolldown', function(){
        var next = $(this).closest('section').next();
        // console.log(next);
        thisGoTo(next, -40);
      });

      $('#nav-button').on('click', function(){
        if(!$('body').hasClass('menu_open')) {
            $('body').addClass('menu_open');
            fix_header_for_menuopen();
            handleMenuVideo(true);
          } else {
            $('body').removeClass('menu_open');
            handleMenuVideo(false);
        }
      });

    }

    function handleMenuVideo(play = true) {
      if ($("video.onMenu").length > 0) {
        // Play video on scroll into view
        $("video.onMenu").each(function(){
          var videoTag = $(this);
          
          if(play) {
            linkVideoSource(videoTag);
            videoTag[0].play();  
          } else {
            videoTag[0].pause();  
          }
        });
      }
    }

    function handleInlineVideo() {
      if ($("video.lazy").length > 0) {
        $(window).on('scroll mousemove', function() {
          // Play video on scroll into view
          if ($("video.lazy").length > 0) {
            $("video.lazy").each(function(){
              var videoTag = $(this);
              
                if (videoTag.isInViewport()) {
                  linkVideoSource(videoTag);
                  videoTag[0].play();
                }
                
            });
          }
        });
      }
    }

    function linkVideoSource(video, className = '') {
      if(video.hasClass('lazy')) {
        var source = video.find('source');
        var src = source.data('src');
        source.attr('src',src);
        video[0].load();
        video.removeClass('lazy').addClass(className);
      }
    }

    function thisLazyLoad() {
      if(typeof lazyLoad === "function"){
        lazyLoad();
      }
    }

    function thisGoTo(target, offset, velocity, ease) {
      if(typeof goTo === "function"){
        goTo(target, offset, velocity, ease);
      }
    }

    // function checkFormFiels() {

    //   var label, container;
    //   $('.wpcf7-form p').each(function(index,item){
    //       label = $(item).find('span.spanlabel'); //.detach(); 
    //       container = $(item).find('.wpcf7-form-control-wrap');
    //       label.appendTo(container);
    //   });

    //   var $wpcf_fields = $('.wpcf7-form-control-wrap input[type!="checkbox"], .wpcf7-form-control-wrap textarea');
    //   $wpcf_fields.each(function(){
    //       var $el = $(this);
          
    //       $el.on('load change click focusout paste autocomplete', function(){
    //           //console.log($(this).val());
    //           if($el.val() != ""){
    //               $el.closest('.wpcf7-form-control-wrap').find('input').addClass('filled');
    //               $el.closest('.wpcf7-form-control-wrap').find('textarea').addClass('filled');
    //           } else {
    //               $el.closest('.wpcf7-form-control-wrap').find('input').removeClass('filled');
    //               $el.closest('.wpcf7-form-control-wrap').find('textarea').removeClass('filled');
    //           }
    //       });
    //   });

    // }


    function fix_header_for_menuopen(){
      var topBarH = $('#top_bar').length > 0 ? $('#top_bar')[0].scrollHeight : 0;
      if(headerTop < (topBarH * -1))
        headerTop = topBarH * -1;
  
      element[0].style.transform = 'translate(0, '+ headerTop +'px)';
    }
  
    function check_header_fromMobile(){
      st = window.pageYOffset || document.documentElement.scrollTop;
      // console.log(st);
      if(st == 0) {
          element[0].classList.remove('h_fixed');
          element[0].style.transform = 'translate(0,0)';
      } else if(st > window.innerHeight / 2 ) {
        element[0].classList.add('h_fixed');
      }
  
    }
    function header_mvmnt() {
      st = window.pageYOffset || document.documentElement.scrollTop;
      // check_header_fromMobile();
      if(st > window.innerHeight / 2 ) {
          element[0].classList.add('h_fixed');
      } 
      var elHeight = element[0].offsetHeight;
  
      if (st > lastScrollTop){
          // downscroll code
          if(headerTop > (elHeight + 10) * -1){                    
              if(Math.abs(st - lastScrollTop) > elHeight){
                  increment = 1;
              } else {
                  increment = Math.abs(st - lastScrollTop);
              }
              headerTop = headerTop - increment;
          } else {
              headerTop = -1 * (elHeight + 10);
          }
      } else {
          // upscroll code
          if(headerTop < 0){
              if(Math.abs(lastScrollTop - st) > elHeight){
                  increment = 10;
              } else {
                  increment = Math.abs(lastScrollTop - st);
              }
              
              if (st == 0) {
                headerTop = 0;
              } else {
                headerTop = headerTop + increment;
              }
          } else {
              headerTop = 0;
          }
      }
  
      if(0 >= headerTop && headerTop >= (elHeight + 10) * -1){
          element[0].style.transform = 'translate(0,'+headerTop+'px)';
      }
      
      lastScrollTop = st <= 0 ? 0 : st;
    }


    function addCookie(name){
      var d=new Date();
      var days = 30;
      d.setTime(d.getTime()+(days * 24 * 60 * 60 * 1000));
      var expires = d.toGMTString();
      document.cookie = name +"=true; expires="+ expires +"; path=/";
    }

  });



  var isMobile = false;
  function is_mobile(){
      if((/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()))){
          isMobile = true;
      } else {
          isMobile = false;
      }
  }

  function detect_touch(){
    if("ontouchstart" in window){
      document.documentElement.className = document.documentElement.className + " touch";
    } else {
      document.documentElement.className = document.documentElement.className + " no_touch";
    }
  }

}(this, $));
